import quiz from "./quizze.png"
import uniLink from "./uniLink.png"
export const workData = [
      {
        "title": "UniLink",
        "description": "Developed a MERN web application enabling users to create, manage, and share personalized collections of links.",
        "url": "https://uni-link-tree.vercel.app/",
        "imgSrc": uniLink
      },
      {
        "title": "Summarizer",
        "description": "Introducing the article summarizer web application! With just a simple link to any news article, this application uses cutting-edge GPT technology to provide you with a clear and concise summary of the content.",
        "url": "https://ai-summarizer-rho.vercel.app/",
        "imgSrc": "https://user-images.githubusercontent.com/63224718/235830211-1d0624fa-31cd-432b-b2fa-3d8c97ce7b2b.png"
      },
      {
        "title": "Quizie",
        "description": "Engineered a React app for creating, sharing, and analyzing quizzes.",
        "url": "https://quizzziee.vercel.app/",
        "imgSrc": quiz
      },
  
      {
        "title": "Metaverse",
        "description": "Crafted a responsive Next.js landing with a metaverse theme, utilizing Framer Motion for animations. Translated Figma design into an interface. ",
        "url": "https://metaverse-ai.vercel.app//",
        "imgSrc": "https://user-images.githubusercontent.com/63224718/259162779-9ea28704-f08c-4abd-a50d-78f1b556f002.png"
      }
    ]